import { Axios } from 'axios'

export type DeliverySlipItem = {
  serialNo: number;
  isDraft: boolean;
  deliveryDate: Date;
  sendDateTime: string;
}

export type DeliverySlipDetail = {
  isDraft: boolean,
  deliveryDate: string,
  userKey: string,
  ccList: string[],
  subject: string,
  body: string
}

export type RequestParams = {
  deliveryDate: string,
  userKey: string,
  ccList: string[],
  subject: string;
  body: string;
}

export type ResponseAdd = {
  serialNo: number;
}

export type ResponseDefaultDraft = {
  subject: string;
  body: string;
}

export interface DeliverySlipService {
  getList(companyKey: string): Promise<DeliverySlipItem[]>;

  getDetail(companyKey: string, serialNo: number): Promise<DeliverySlipDetail>;

  getDefaultDraft(): Promise<ResponseDefaultDraft>;

  addDraft(companyKey: string, requestParams: RequestParams): Promise<ResponseAdd>;

  updateDraft(companyKey: string, serialNo: number, requestParams: RequestParams): Promise<void>;

  sendSlip(companyKey: string, serialNo: number): Promise<void>;

  deleteDraft(companyKey: string, serialNo: number): Promise<void>;
}

export class DeliverySlipServiceImpl implements DeliverySlipService {
  constructor (http: Axios) {
    this.http = http
    this.baseUrl = 'system/delivery-slip'
  }

  private readonly http: Axios

  private readonly baseUrl: string;

  async getList (companyKey: string): Promise<DeliverySlipItem[]> {
    const { data } = await this.http.get(`${this.baseUrl}/${companyKey}`)
    return data
  }

  async getDetail (companyKey: string, serialNo: number): Promise<DeliverySlipDetail> {
    const { data } = await this.http.get(`${this.baseUrl}/${companyKey}/${serialNo}`)
    return data
  }

  async getDefaultDraft (): Promise<ResponseDefaultDraft> {
    const { data } = await this.http.get(`${this.baseUrl}/default-draft`)
    return data
  }

  async addDraft (companyKey: string, requestParams: RequestParams): Promise<ResponseAdd> {
    const { data } = await this.http.post(`${this.baseUrl}/${companyKey}`, requestParams)
    return data
  }

  async updateDraft (companyKey: string, serialNo: number, requestParams: RequestParams): Promise<void> {
    const url = `${this.baseUrl}/${companyKey}/${serialNo}`
    const { data } = await this.http.put(url, requestParams)
    return data
  }

  async sendSlip (companyKey: string, serialNo: number): Promise<void> {
    const url = `${this.baseUrl}/${companyKey}/${serialNo}/send`
    await this.http.post(url)
  }

  async deleteDraft (companyKey: string, serialNo: number): Promise<void> {
    await this.http.delete(`${this.baseUrl}/${companyKey}/${serialNo}`)
  }
}
